var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9849 11.6761L20.3236 8L26.6621 11.6761L24.3318 13.0341L20.3236 10.7161L16.3153 13.0341L13.9849 11.6761ZM26.6621 16.3122L24.3318 14.9541L20.3236 17.2722L16.3153 14.9541L13.9849 16.3122V19.0282L17.9932 21.3463V25.9824L20.3236 27.3405L22.6538 25.9824V21.3463L26.6621 19.0282V16.3122ZM26.6621 23.6644V20.9483L24.3318 22.3063V25.0224L26.6621 23.6644ZM28.3167 24.6244L24.3085 26.9424V29.6585L30.647 25.9824V18.6302L28.3167 19.9883V24.6244ZM25.9863 13.9941L28.3167 15.3522V18.0683L30.647 16.7102V13.9941L28.3167 12.6361L25.9863 13.9941ZM17.9932 27.9258V30.6419L20.3236 32L22.6538 30.6419V27.9258L20.3236 29.2839L17.9932 27.9258ZM13.9849 23.6644L16.3153 25.0224V22.3063L13.9849 20.9483V23.6644ZM17.9932 13.9941L20.3236 15.3522L22.6538 13.9941L20.3236 12.6361L17.9932 13.9941ZM12.3304 15.3522L14.6607 13.9941L12.3304 12.6361L10 13.9941V16.7102L12.3304 18.0683V15.3522ZM12.3304 19.9883L10 18.6302V25.9824L16.3386 29.6585V26.9424L12.3304 24.6244V19.9883Z",
    fill: "#F0AD00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.b1b50c3e74db963bb3313dbad3a31855.svg";
export { ForwardRef as ReactComponent };